module.exports = __webpack_public_path__ + "img/RCCN-LOGO.68034fa3.png";